import { render, staticRenderFns } from "./ThgPrivacy.vue?vue&type=template&id=a7a79dc8&scoped=true"
import script from "./ThgPrivacy.vue?vue&type=script&lang=ts"
export * from "./ThgPrivacy.vue?vue&type=script&lang=ts"
import style0 from "./ThgPrivacy.vue?vue&type=style&index=0&id=a7a79dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a79dc8",
  null
  
)

export default component.exports